var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#222B45"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.05c.159 0 .318.038.463.113l3.769 1.97-.717-4.157c-.057-.326.052-.658.29-.889l3.036-2.936-4.203-.612c-.325-.047-.606-.25-.752-.544L12 5.201l-1.886 3.794c-.146.294-.427.497-.752.544l-4.203.612 3.036 2.936c.238.231.347.563.29.889l-.717 4.157 3.769-1.97c.145-.075.304-.113.463-.113m5.562 4.905c-.16 0-.318-.037-.463-.113l-5.1-2.664-5.098 2.664c-.338.176-.746.145-1.051-.079-.308-.224-.461-.603-.397-.978l.972-5.628-4.12-3.985c-.275-.265-.373-.663-.256-1.026.116-.363.43-.627.807-.682l5.7-.828 2.548-5.126c.338-.68 1.454-.68 1.792 0l2.547 5.126 5.7.828c.378.055.692.319.808.682.117.363.019.761-.256 1.026l-4.12 3.985.972 5.628c.064.375-.09.754-.397.978-.173.128-.38.192-.588.192",
    transform: "translate(-844 -104) translate(844.483 104.5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsStar);
export default __webpack_public_path__ + "static/media/icons-star.195ab59f.svg";
export { ForwardRef as ReactComponent };